import {
  getItems,
  removeItem,
  downloadItemsToCsv,
  getItem,
  updateItem,
  getCategories,
  deleteFile
} from '../services/napi';
import {
  ITEMS_FETCH_SUCCESS,
  GET_ITEM_SUCCESS,
  DOWNLOAD_ITEMS,
  ITEM_LOADING,
  SET_ITEM_DRAFT,
  SET_ITEM_ADDRESS_DRAFT,
  SET_ITEM_OPTIONS_DRAFT,
  CATEGORIES_FETCH_SUCCESS,
  SET_ITEM_IMAGES_DRAFT
} from '../constant/actionType';

export function fetchItems() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getItems(projectId);
    dispatch({ data: response.data.items, type: ITEMS_FETCH_SUCCESS });
  };
}

export function fetchCategoriesAction() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getCategories(projectId);
    dispatch({
      data: response.data.categories,
      type: CATEGORIES_FETCH_SUCCESS
    });
  };
}

export function removeItemAction(selectedItems) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    await removeItem(projectId, selectedItems.id);
  };
}

export function downloadItemsToCsvAction() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await downloadItemsToCsv(projectId);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `items.csv`);
    document.body.appendChild(link);
    link.click();
    dispatch({
      data: response.data,
      type: DOWNLOAD_ITEMS
    });
  };
}

export function fetchItemAction(itemId) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getItem(projectId, itemId);

    dispatch({ data: response.data.item, type: GET_ITEM_SUCCESS });
  };
}

export function updateItemAction(itemId, deletedImagesIds, itemDraftState) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const { itemDraft } = getState().item;
    const newItemData = { ...itemDraft, ...itemDraftState };
    await updateItem(projectId, itemId, newItemData);
    await Promise.all(
      deletedImagesIds.map(async (imageId) => {
        await deleteFile(imageId, projectId);
      })
    );
    await dispatch(fetchItemAction(itemId));
    // dispatch({ type: UPDATE_ITEM_SUCCESS, data: response.data.item });
  };
}

export function cleanupAction() {
  return (dispatch) => {
    dispatch({
      type: ITEM_LOADING
    });
  };
}

export function setItemDraft(data) {
  return async (dispatch) => {
    dispatch({
      data,
      type: SET_ITEM_DRAFT
    });
  };
}

export function setItemAddressDraft(data) {
  return async (dispatch) => {
    dispatch({
      data,
      type: SET_ITEM_ADDRESS_DRAFT
    });
  };
}

export function setItemOptionsDraft(data) {
  return async (dispatch) => {
    dispatch({
      data,
      type: SET_ITEM_OPTIONS_DRAFT
    });
  };
}
export function setItemsImagesDraft(data) {
  return async (dispatch) => {
    dispatch({
      data,
      type: SET_ITEM_IMAGES_DRAFT
    });
  };
}
